import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const ChannelItem = ({channel, channelList}) => {
    const [channelName, setChannelName] = useState('');
    const [URL, setURL] = useState('');
    const [channelLogo, setChannelLogo] = useState({});

    useEffect(() => {
        channelList.forEach(item => {
            if (item.id === channel) {
                setChannelName(item.name);
                setURL(item.url);
                setChannelLogo(item.media.default);
            }
        });
    }, [channel]);

    return (
        <>
            <li className="package-channels__list-item" data-channel-id={channel}>
                <Link className={`package-channels__channel js-package-channels-tooltip-${channel}`} to={`//telekarta.tv/tvprogram/channels/${URL}`} data-tooltip-content={"#tooltip-channel-" + channel}>
                    <div className="package-channels__channel-logo">
                        <img src={channelLogo.url} width="64" height="64" alt={channelName}/>
                    </div>
                    <span className="package-channels__channel-name">{channelName}</span>
                </Link>
            </li>
        </>
    );
};

export default ChannelItem;